<div class="item-detail-container">

    @if(loading()){
        <!-- Skeleton al estilo de equipos -->
        <div class="glass-header-skeleton p-5 border-round-2xl shadow-1 mb-4">
            <div class="flex align-items-center gap-4">
                <p-skeleton width="64px" height="64px" borderRadius="16px"></p-skeleton>
                <div class="flex flex-column gap-2 flex-grow-1">
                    <p-skeleton width="40%" height="2rem"></p-skeleton>
                    <p-skeleton width="25%" height="1rem"></p-skeleton>
                </div>
                <p-skeleton width="120px" height="2.5rem" borderRadius="2rem"></p-skeleton>
            </div>
        </div>
        <div class="grid mb-4">
            <div class="col-3"><p-skeleton height="5rem" borderRadius="14px"></p-skeleton></div>
            <div class="col-3"><p-skeleton height="5rem" borderRadius="14px"></p-skeleton></div>
            <div class="col-3"><p-skeleton height="5rem" borderRadius="14px"></p-skeleton></div>
            <div class="col-3"><p-skeleton height="5rem" borderRadius="14px"></p-skeleton></div>
        </div>
        <p-skeleton width="100%" height="500px" borderRadius="20px"></p-skeleton>
    } @else {
        <div class="item-detail-content">
            <app-item-form
                [item]="item()"
                [mode]="mode()"
                [(activeTab)]="activeTab"
                (onSave)="onSave($event)"
                (onCancel)="onCancel()"
                (onBack)="goBack()"
                (onModeChange)="onModeChange($event)">
            </app-item-form>
        </div>
    }
</div>
